import type {MergeConditionPayload, MergeConditionWithSubConditionsPayload} from '../page-data/payloads/merge-box'
import {USER_CANNOT_PUSH_SUBCONDITION} from './json-api-helpers'

type AgentMergeVisibility = {
  isOpen: boolean
  isFeatureEnabled: boolean
  viewerCanUseCopilotCodingAgent: boolean
  repositoryStateCondition: Pick<MergeConditionPayload, 'result'> | undefined
  userStateCondition: MergeConditionWithSubConditionsPayload | undefined
  isUserBlockedFromPushing: boolean
  isConfirmingMergeInfo: boolean
  isStacked: boolean
}

function canUserUseAgentMerge(userStateCondition: MergeConditionWithSubConditionsPayload | undefined) {
  return (
    !!userStateCondition &&
    userStateCondition.result !== 'UNKNOWN' &&
    !userStateCondition.failedSubConditions.some(
      subCondition => subCondition.displayName === USER_CANNOT_PUSH_SUBCONDITION,
    )
  )
}

export function shouldShowAgentMerge({
  isOpen,
  isFeatureEnabled,
  viewerCanUseCopilotCodingAgent,
  repositoryStateCondition,
  userStateCondition,
  isUserBlockedFromPushing,
  isConfirmingMergeInfo,
  isStacked,
}: AgentMergeVisibility) {
  return (
    isOpen &&
    isFeatureEnabled &&
    // Agent Merge hands the pull request to the Copilot cloud agent, so it can only be
    // offered where that agent is available to this viewer on this repository — the same
    // gate the Conflicts and Checks sections use for their Copilot actions.
    viewerCanUseCopilotCodingAgent &&
    repositoryStateCondition?.result !== 'FAILED' &&
    canUserUseAgentMerge(userStateCondition) &&
    !isUserBlockedFromPushing &&
    !isConfirmingMergeInfo &&
    !isStacked
  )
}
